/* eslint-disable object-curly-newline */
const checkoutBtn = $(".product__button--checkout");
const addToCartBtn = $(
  ".product__button--atc, .shop-mygolo-product-card__button--atc"
);
const iconMinus = $(
  ".product__quantity--container .icon-minus:not(.disable-link)"
);
const iconPlus = $(
  ".product__quantity--container .icon-plus:not(.disable-link)"
);
const cartModal = $("#modal-mygolo-cart");

let superFoodsProducts = {};

try {
  superFoodsProducts = JSON.parse(
    document.currentScript.getAttribute("sfe-collection")
  );
} catch (error) {
  console.warn("Failed to get SFE products collection:", error);
}

// boolean to skip cartModal and go right to cart
// - currently only for myGOLO AeroTrainer Product page
const skipModalGoToCart = addToCartBtn.eq(0).hasClass("aerotrainer");
// customer has reached max quantity for item
let hasReachedMaxQty = false;

cartModal.modal("hide");

/**
 * Temporarily changes the text displayed for buttons on the myGOLO shop page
 * @param {object} el HTML element used to display the message
 * @param {string} msg New message displayed to user when selecting a button
 * @param {string} originalMessage Original message displayed on the button
 * @param {boolean} triggersModal Determines if modal should be displayed
 * @param {number} timeout Timeout value in milliseconds
 * @returns {object} Function that sets the timeout value
 */
const setMessageAndTimeout = (el, msg, triggersModal, timeout) => {
  const ariaElement = el.nextElementSibling;
  const originalMessage = $(el)
    .find(".shop-mygolo-product-card__button--atc__text")
    .text();
  $(el).find(".shop-mygolo-product-card__button--atc__text").text(msg);
  $(ariaElement).html(msg);
  $([el, ariaElement]).prop("disabled", true);

  if (triggersModal) {
    cartModal.modal("show");
    cartModal.focus();
  } else if (!hasReachedMaxQty && skipModalGoToCart) {
    // go directly to cart
    return (window.location.href = "/cart");
  }

  showLoadingButton($(el), false);

  setTimeout(() => {
    $(ariaElement).html(originalMessage);
    $(ariaElement).prop("disabled", false);
  }, 6000);
  return setTimeout(() => {
    $(el)
      .find(".shop-mygolo-product-card__button--atc__text")
      .text(originalMessage);
    $(el).prop("disabled", false);
  }, timeout);
};

/**
 * Passes variables to the setMessageAndTimeout function to set temporary text
 * on the myGOLO shop page buttons, and sets a timeout with a default of
 * 1000 millseconds
 * @param {object} el HTML element used to display the message
 * @param {string} msg New message displayed to user when selecting a button
 * @param {string} originalMessage Original message displayed on the button
 * @param {boolean} triggersModal Determines if modal should be displayed
 * @param {number} timeout Timeout value in milliseconds. Default is 1000.
 * @returns {object} Function that sets the timeout value
 */
const cartMessage = (el, msg, triggersModal, timeout = 1000) => {
  return setMessageAndTimeout(el, msg, triggersModal, timeout);
};

/**
 * Adjusts the quantity based on addition or subtraction of an item
 * @param {object} classElement The HTML element for element selected
 * @param {string} operation The current operation for the element selected
 * @param {number} max Maximum times that the operation can be selected
 * @returns {number} Returns number for adjusting the quantity on selecting
 * an operation
 */
handleQuantityChange = (classElement, operation) => {
  const productQuantity = $(".product__quantity." + classElement);
  productQuantity.val((index, quantity) => {
    max = productQuantity.attr("data-max");
    if (operation === "plus") {
      const newVal = parseInt(quantity) + 1 > max ? max : ++quantity;
      return newVal;
    } else {
      if (parseInt(quantity) > 0) {
        return --quantity;
      }
      return 0;
    }
  });
  productQuantity.emit("change");
  productQuantity
    .closest(".product__quantity--container")
    .find(".shop-mygolo-quantity")
    .html(productQuantity.val());
  return productQuantity.val();
};

iconMinus.on("click", function () {
  return handleQuantityChange($(this).attr("data-target"), "minus");
});

iconPlus.on("click", function () {
  return handleQuantityChange($(this).attr("data-target"), "plus");
});

/**
 * Gets the variant that the user selected, and adds it to a site reader tag
 * on the shop myGOLO page
 * @param {event} event Passes in the JavaScript event used on Shop myGOLO page
 * @returns {html} Returns variant information to site reader tag
 */
getProductQuantityText = (event) => {
  const isClickOrEnter = (event) =>
    event.type === "click" ||
    (event.type === "keydown" && event.which === 13) ||
    (event.type === "keydown" && event.which === 32);

  if (isClickOrEnter(event)) {
    const $liElement = $(event.currentTarget);
    const inputElement = $liElement.children("input");
    // TODO: update selector to accept just :checked without space
    if (inputElement.is(" :checked")) {
      variantProductName = inputElement.data("sr-name");
      const productGroupingDiv = $liElement.closest(
        ".product-grouping__variants"
      );
      productGroupingDiv.find(".shop-mygolo-variant").html(variantProductName);
    }
  }
};

/**
 * Handles adding/updating items and price for cart
 * @returns {object} Returns cart object with message displayed
 */
addToCartBtn.on("click", async function (e) {
  const productHandle = this.dataset["value"];
  const hasVariants = this.dataset["hasvariants"];
  let cartTotalPrice = 0;
  let cartTotalItemCount = 0;
  let productVariantId;
  let quantity;
  let maxQuantity;
  let inventoryQuantity;
  // Hides any text that was displayed for a product that was previously added
  // to the cart
  $(".max-quantity-notice").removeClass("d-block");

  showLoadingButton($(e.currentTarget));

  return golo.client.ajax.cart
    .get({ extendedData: true })
    .then((res) => res.data)
    .then(async (cart) => {
    // Adds Products with Variants
    if (parseInt(hasVariants) === 0) {
      productVariantId = $(
        ":radio[data-name='" + productHandle + "']:checked"
      ).attr("value");
      quantity = $(".product__quantity." + productHandle).val() ?? 1;
      //Handles max quantity for products with variants
      maxQuantity =
        $(".product__radio." + productVariantId).attr("data-max") || 5;
      inventoryQuantity =
        $(".product__radio." + productVariantId).attr("data-inventory") || 5;
      /*
       * Handles scenarios if a user tries to add an item with a radio button
       * without selecting a variant type
       */
      if (
        // TODO: update selector to accept just :checked without space
        $(":radio[data-name='" + productHandle + "']").is(" :checked") === false
      ) {
        let message;
        if (
          productHandle === "release-reorders" ||
          productHandle === "golo-go-digest"
        ) {
          // eslint-ignore max-len
          // Message returned if the user did not select a month's supply
          message = "PLEASE SELECT A MONTH SUPPLY";
        } else if (productHandle === "golo-for-life-plan") {
          // Message returned if the user did not select an option
          message = "PLEASE SELECT A PLAN";
        } else if (
          productHandle === "golo-t-shirt" ||
          productHandle === "golo-t-shirt-light-blue"
        ) {
          // Message returned if the user did not select a size
          message = "PLEASE SELECT A SIZE";
        } else {
          // Message returned if the user did not select an option
          message = "PLEASE SELECT AN OPTION";
        }
        return cartMessage(this, message);

        // Logic for if a user selects an option from a product with a variant
      }
    } else {
      productVariantId = $(this).attr("data-product");
      quantity = $(".product__quantity." + productHandle).val();
      maxQuantity =
        $(".product__quantity." + productHandle).attr("data-max") || 5;
      inventoryQuantity = maxQuantity;
    }
    let variantQty = 0;
    cartItemsSize = cart.items.length;
    cartTotalPrice = cart.total_price;

    if (parseInt(quantity) > 0) {
      /*
       * For each item in the cart, update the variant quantity value with the
       * item's quantity that was selected
       */
      cart.cart_items_extended_data.forEach((item) => {
        if (item.variant_id === parseInt(productVariantId)) {
          inventoryQuantity = item.inventory_quantity;
          if (
            inventoryQuantity > 0 &&
            inventoryQuantity < parseInt(maxQuantity)
          ) {
            maxQuantity = inventoryQuantity;
          }
          variantQty = item.quantity;
          return (isVariantEqual = true);
        }
      });

      // Verifies that the variant quantity does not go over the max quantity
      if (
        parseInt(inventoryQuantity) > 0 &&
        parseInt(inventoryQuantity) < parseInt(maxQuantity)
      ) {
        maxQuantity = inventoryQuantity;
      }
      if (parseInt(variantQty) < parseInt(maxQuantity)) {
        let currentQuantityOfItem = 0;
        // Checks if product is already in the cart
        if (
          cart.items.some((item) => {
            const isCurrentItem =
              item.variant_id === parseInt(productVariantId);
            currentQuantityOfItem = isCurrentItem
              ? item.quantity
              : currentQuantityOfItem;
            return isCurrentItem;
          })
        ) {
          // Updates products that are already in the cart that are not variants
          const updateQuantity =
            parseInt(quantity) + currentQuantityOfItem > maxQuantity
              ? maxQuantity
              : parseInt(quantity) + currentQuantityOfItem;
  
          getCartUtil()
            .update({ [productVariantId]: updateQuantity })
            .then(res => res.data)
            .then(async (data) => {
              const adjustedQuantity = updateQuantity - currentQuantityOfItem;
              const modal = $(document).find("#modal-mygolo-cart");
              let foodItemQuantity = 0;
              if (modal.find(".product-row").length < 1) {
                data.items.forEach((item) => {
                  if (
                    modal.find(".product-row[data-id='" + item.variant_id + "']")
                      .length < 1
                  ) {
                    appendModalCartContent(item);
                  }
                });
              }

              $(
                ".product-row[data-id='" + productVariantId + "'] .item__quantity"
              ).html(`${updateQuantity}`);

              $(".items--added__count").html(`${adjustedQuantity}`);

              $(".items--total__count").html(`${data.item_count}`);
              $(".cart__total-price").html(
                `$${(data.total_price / 100).toFixed(2)}`
              );
              if (data.item_count === 1) {
                $(".items--total__label").html("item");
              } else {
                $(".items--total__label").html("items");
              }
              if (parseInt(adjustedQuantity) === 1) {
                $(".items--added__label").html("item");
              } else {
                $(".items--added__label").html("items");
              }
          });
          return cartMessage(this, "ADD TO CART", !skipModalGoToCart);
        } else {
          // Adds products without variants to the cart
          if (maxQuantity >= parseInt(quantity)) {
            const { data } = await getCartUtil().get();
            const currentQuantity = data.items.find((item) => item.id === productVariantId) ?? 0;
            getCartUtil()
              .update({ [productVariantId]: parseInt(currentQuantity + quantity)})
              .then(res => res.data)
              .then(async (data) => {
                cartTotalItemCount += cart.items.length;

                // append each item to the cart
                const modal = $(document).find("#modal-mygolo-cart");
                data.items.forEach((item) => {
                  if (
                    modal.find(".product-row[data-id='" + item.variant_id + "']")
                      .length < 1
                  ) {
                    appendModalCartContent(item);
                  }
                  cartTotalPrice += item.discounted_price * item.quantity;
                  cartTotalItemCount += item.quantity;
                });
                getCartUtil()
                  .get({ extendedData: true })
                  .then(res => res.data)
                  .then((UpdatedCart) => {
                  // update cart total and verbiage
                  $(".cart__total-price").html(
                    `$${(UpdatedCart.total_price / 100).toFixed(2)}`
                  );
                  $(".items--added__count").html(`${quantity}`);
                  $(".items--total__count").html(`${UpdatedCart.item_count}`);
                  $(".items--total__label").html(
                    UpdatedCart.item_count === 1 ? "item" : "items"
                  );
                  $(".items--added__label").html(
                    parseInt(quantity) === 1 ? "item" : "items"
                  );

                  // Message returned after the item was successfully added
                  return cartMessage(this, "ADD TO CART", !skipModalGoToCart);
                });
            });
          } else {
            // message if the user tries to add more than the max-quantity
            hasReachedMaxQty = true;
            return cartMessage(this, "YOU HAVE REACHED MAX QUANTITY");
          }
        }
      } else {
        // Message returned if the user tries to add more than the max-quantity
        hasReachedMaxQty = true;
        return cartMessage(this, "YOU HAVE REACHED MAX QUANTITY");
      }

      // Displays text div that tells the user the maximum quantity for product
      // that is currently being added to the cart
      $(
        ".product-row[data-id='" + productVariantId + "'] .max-quantity-notice"
      ).addClass("d-block");

      // Adds the max quantity to the span tag for the product being added
      // to the cart
      $(
        ".product-row[data-id='" +
          productVariantId +
          "'] .max-quantity-notice .item__max-quantity"
      ).html(maxQuantity);

      // Gets the current items in the cart
      getCartUtil()
        .get()
        .then(res => res.data)
        .then(async (cart) => {
          // Show the warning message in the modal about Canadian shipping
          // if there is a superfood item in the customer's cart
          const $warning = $("#superfood-shipping-warning");

          if ($warning.data("has-canadian-address") != "false") {
            for (const item of cart.items) {
              const inSFECollection =
                superFoodsProducts.find &&
                superFoodsProducts.find((prod) => prod.handle === item.handle);
              if (inSFECollection) {
                $warning.removeClass("d-none");
                break;
              } else {
                $warning.addClass("d-none");
              }
            }
          }

          const $shippingCharge = $("#superfood-shipping-charge");
          for (const item of cart.items) {
            if (item.sku.startsWith("F")) {
              $shippingCharge.removeClass("d-none");
              break;
            } else {
              $shippingCharge.addClass("d-none");
            }
          }

          // Message returned after the item was successfully added to the cart
          return cartMessage(this, "ADD TO CART");
      });
    } else {
      // Message returned if the user did not select a quantity
      return cartMessage(this, "PLEASE SELECT QUANTITY AMOUNT");
    }
  });
});

/**
 * Mygolo proceed to checkout button
 * @returns {object} Returns cart object
 */
checkoutBtn.on("click", async function () {
  return await getCartUtil()
    .get()
    .then(res => res.data)
    .then((cart) => {
      if (cart.item_count === 0) {
        return cartMessage(checkoutBtn, "PLEASE SELECT A PRODUCT", false, 2000);
      } else {
        checkoutBtn.prop("disabled", true);
        return (window.location.href = "/cart");
      }
  });
});

/*
 * Reset the checkout button behavior on Safari when reaching the page
 * via back button
 */
window.onpageshow = (event) => {
  if (event.persisted) {
    getCartUtil().get({ extendedData: true })
      .then(res => res.data)
      .then(async (cart) => {
        $(".cart-items").empty();
        const modal = $(document).find("#modal-mygolo-cart");
        cart.items.forEach((item) => {
          if (
            modal.find(".product-row[data-id='" + item.variant_id + "']")
              .length < 1
          ) {
            appendModalCartContent(item);
          }
        });
        $(".items--total__count").html(`${cart.item_count}`);
        $(".cart__total-price").html(`$${(cart.total_price / 100).toFixed(2)}`);
        if (cart.item_count === 1) {
          $(".items--total__label").html("item");
        } else {
          $(".items--total__label").html("items");
        }
      });
    checkoutBtn.prop("disabled", false);
  }
};

/**
 * Appends item to mygolo modal cart
 * @param {object} data
 * @returns {html} Returns html for specific items
 */
function appendModalCartContent(data) {
  const getPrice = (amount) => (amount / 100).toFixed(2);

  /* eslint-disable camelcase */
  const { original_price, discounted_price } = data;

  const totalString =
    original_price === discounted_price
      ? getPrice(original_price)
      : `<span class="item__price--original">$${getPrice(
          original_price
        )}</span>$${getPrice(discounted_price)}`;
  /* eslint-enable camelcase */

  /* eslint-disable max-len */
  const html = `
    <div class="col-12 p-0 product-row d-flex flex-wrap justify-content-center"
      data-id="${data.variant_id}">
    <div class="col-12 col-sm-5 d-flex justify-content-center flex-wrap p-4">
      <div class="image-container mb-4">
        <img  
          class="d-block m-auto lazyload" 
          src="${data.image}"
          data-src="${data.image}" 
          data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]"
          data-aspectratio="{{ responsive-image.aspect_ratio }}" 
          data-sizes="auto" 
          alt="${
            data.handle === "release-reorders" ? data.product_title : data.title
          }"
        />
      </div>
    </div>
    <div class="col-12 p-0 pl-lg-4 col-sm-7 d-flex justify-content-center flex-wrap my-4 my-sm-0 align-items-center">
      <div class="col-12 p-0">
        <h2 class="heading-1 fw-700 fs-24 mb-2 item__title">
          ${
            data.handle === "release-reorders" ? data.product_title : data.title
          }
        </h2>
        <p class="body-1 color-primary item__details fw-600">
          <span class="item__quantity">${data.quantity}</span> X
          <span class="item__price">${totalString}</span>
          <p class="max-quantity-notice color-primary fw-500 d-none"><span class="item__max-quantity"></span> is the maximum quantity allowed for this product.</p>
        </p>
      </div>
    </div>
  </div>`;
  /* eslint-enable max-len */

  $(".cart-items").append(html);
}

/*
 * Functions as psuedo class :focus-within
 * Support for Microsoft edge
 */
focusParent = (parent, flag) => {
  parent.css("outline", flag ? "#E4F1FE solid 3px" : "");
};

// Checks the input radio when focused on
$('input[type="radio"]').on("focus focusout", function (e) {
  $parent = $(this).parent("label");
  if (e.type === "focus") {
    $(this).trigger("click");
    focusParent($parent, true);
  } else if (e.type === "focusout") {
    focusParent($parent, false);
  }
});

// Allows keyboard interaction on icon-plus and icon-minus
$("span.icon-minus, span.icon-plus").on("keydown", function (e) {
  if (e.keyCode === 13) {
    e.preventDefault();
    $(this).trigger("click");
  }
});

const showLoadingButton = (button, show = true) => {
  if (typeof button === "string") {
    button = $(button);
  }
  button.find(".loadingIndicator").toggleClass("d-none", !show);
  button
    .find(".shop-mygolo-product-card__button--atc__text")
    .toggleClass("d-none", show);
};

const getCartUtil = () => {
  return window.golo.client.ajax.cart;
}
